import React from "react";
import { Train } from "lucide-react";
import NewsletterSignup from "./NewsletterSignup";

/**
 * PreFooterNewsletter
 * --------------------------------------------------------------------------
 * Prominent, full-width newsletter band that sits immediately above the site
 * footer on every public page (mounted in components/Layout.jsx). Same copy
 * appears in the 20-second first-visit popup so the message reads
 * consistently either way the visitor encounters it.
 */
export default function PreFooterNewsletter() {
  return (
    <section
      data-testid="pre-footer-newsletter"
      className="relative bg-[#0F1B2E] text-white overflow-hidden"
    >
      {/* Faint rail-motif accent */}
      <div
        aria-hidden="true"
        className="absolute inset-y-0 -right-16 w-64 opacity-[0.06] pointer-events-none"
        style={{
          background:
            "repeating-linear-gradient(90deg, transparent 0 22px, #E63B2E 22px 24px)",
        }}
      />
      <div className="max-w-6xl mx-auto px-6 py-14 sm:py-16 relative">
        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-3">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.25em] text-slate-200 mb-4">
              <Train className="w-3.5 h-3.5 text-[#E63B2E]" />
              Career update list
            </div>
            <h2
              className="tdf-heading text-3xl sm:text-4xl leading-tight text-white"
              data-testid="pre-footer-heading"
            >
              Move closer to the driver&rsquo;s seat.
            </h2>
            <p className="text-sm sm:text-base text-slate-300 mt-3 max-w-xl leading-relaxed">
              Get train driver recruitment updates, preparation tips, application
              guidance and career articles to help you plan your next step.
            </p>
            <ul className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-xs text-slate-300">
              <li>Recruitment window alerts</li>
              <li>Application &amp; CV guidance</li>
              <li>Assessment &amp; interview prep</li>
              <li>Unsubscribe any time</li>
            </ul>
          </div>
          <div className="lg:col-span-2">
            <div className="bg-white/[0.06] border border-white/10 rounded-2xl p-5 sm:p-6 backdrop-blur-sm">
              <NewsletterSignup
                source="pre_footer"
                dark
                ctaLabel="Start Preparing"
              />
              <p className="text-[11px] text-slate-400 mt-3 leading-snug">
                One email at a time — no spam, no shared lists. Read our{" "}
                <a
                  href="/privacy"
                  className="underline underline-offset-2 hover:text-white"
                >
                  privacy notice
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
